import setFullbanner from './home/1_fullbanner'; 
import setHomeCtaMarquee from './home/home_cta_marquee';
import setGooeyTextMorphing from './home/gooey_text_morphing';
import setIconsVertical from './home/icons_vertical';
import setBannersLinha from './home/home_banner_linha';
import setProductSlider from './home/3_product_slider';
import setReviewsSwiper from './home/reviews';
import CategoryTabs from './home/3_category_tabs';
import setBrandsCarousel from './home/brands_carousel';
import setHomeProductVideos from './home/home_videos_products';
import ShopLook from './home/shop_the_look';
import setQuotationVerticalSwiper from './home/3_quotation';
import setBlogHighlightsSwiper from './home/3_categories';
import setSliderGrids from './home/4_categories';
import setAnimatedSlideshow from './home/animated_slideshow';
import setAlternatedBannersFilters from './home/4_banners_alternados_filters';

//addImports
import setupBannerBlackFriday from '../components/banner';
import setupShuffleGrid from '../components/shuffle_grid';

import setTopBar from '../components/topBar';
import handleConditionalLazy from '../components/conditionalLazy';
import '../common/modalCupom';
import '../components/ai_features';


const Home = {
  init: function () {
    setTopBar();
    handleConditionalLazy();
    setupBannerBlackFriday();
    setupShuffleGrid();

    setFullbanner()
    setHomeCtaMarquee();
    setGooeyTextMorphing();
		setIconsVertical();
		setBannersLinha();
		setProductSlider()
		setReviewsSwiper();
		CategoryTabs.init();
		setBrandsCarousel();
		setHomeProductVideos.init()
		ShopLook.init()
		setQuotationVerticalSwiper();
		setBlogHighlightsSwiper();
		setSliderGrids(); 
		setAnimatedSlideshow();
		setAlternatedBannersFilters();
		
		
		//calls
  },
};

window.addEventListener('DOMContentLoaded', () => {
  Home.init();
});
